import { ENV } from '~/common/enums/enums';
import { SeoPayload } from '~/common/types/types';

const seoPayload: SeoPayload = {
  title: 'seo.js.title',
  description: 'seo.js.description',
  siteUrl: ENV.APP.URL,
};

export { seoPayload };
